export const HANDLEBARS_BOOLEAN_TRUE = 'true';
export const HANDLEBARS_BOOLEAN_FALSE = 'false';
export const HANDLEBARS_NULL = 'null';
export const HANDLEBARS_UNDEFINED = 'undefined';
